export default __webpack_public_path__ + "static/media/b13-med.19877a7e.jpg";